<template>
  <b-row>
    <b-col
      md="12"
    >
      <b-form-group
        label="Type"
        label-size="sm"
      >
        <validation-provider
          #default="{ errors }"
          name="type"
          rules="required"
        >
          <v-select
            id="slot-type"
            v-model="content.delivery_type"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :reduce="(text) => text.value"
            label="text"
            :options="typeBima"
            :state="errors.length > 0 ? false : null"
            @input="setType"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
    <b-col
      md="12"
    >
      <b-form-group
        :label="(content.delivery_type === 1) ? 'Broadcast Title' : 'Title'"
        label-for="broadcast-title"
        :description="`Remaining Char: ${remainingTitle} Char`"
      >
        <validation-provider
          #default="{ errors }"
          name="Title"
          rules="required|max50"
        >
          <b-form-input
            id="broadcast-title"
            v-model="content.broadcast_title"
            name="broadcast_title"
            placeholder="Title"
            rows="3"
            :state="errors.length > 0 ? false : null"
            @keyup="countdownTitle"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
    <b-col
      v-if="(content.delivery_type === 1)"
      md="12"
    >
      <b-form-group
        label="Broadcast Message"
        label-for="broadcast-message"
        :description="`Remaining Char: ${remainingMessage} Char`"
      >
        <validation-provider
          #default="{ errors }"
          name="Broadcast Message"
          rules="required|max100"
        >
          <b-form-textarea
            id="broadcast-message"
            v-model="content.broadcast_message"
            placeholder="Add Message"
            rows="3"
            :state="errors.length > 0 ? false:null"
            @keyup="countdownMessage"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
    <b-col
      v-if="(content.delivery_type === 2)"
      md="12"
    >
      <b-form-group
        label="Description"
        label-for="broadcast-description"
        :description="`Remaining Char: ${remainingDesc} Char`"
      >
        <validation-provider
          #default="{ errors }"
          name="Description"
          rules="required|max100"
        >
          <b-form-textarea
            id="broadcast-description"
            v-model="content.broadcast_description"
            placeholder="Add Description"
            rows="3"
            :state="errors.length > 0 ? false:null"
            @keyup="countdownDesc"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
    <b-col
      v-if="(content.delivery_type === 1)"
      md="6"
    >
      <b-form-group
        label="Broadcast Banner 824x386 px"
        label-for="banner"
      >
        <validation-provider
          #default="{ errors }"
          name="Banner"
          rules="required|dimensions824x386"
        >
          <b-form-file
            id="banner"
            v-model="content.banner"
            name="banner"
            accept="image/*"
            placeholder="Upload Image"
            :state="errors.length > 0 ? false : null"
            @change="onFileChange"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
    <b-col
      :md="(content.delivery_type === 1) ? '6' : '12'"
    >
      <b-form-group
        label="Broadcast Link"
        label-for="broadcast-link"
      >
        <validation-provider
          #default="{ errors }"
          name="broadcast_link"
          rules="required"
        >
          <b-form-input
            id="broadcast-link"
            v-model="content.broadcast_link"
            name="broadcast_link"
            placeholder="domain.com/xxxxx"
            rows="3"
            :state="errors.length > 0 ? false : null"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
    <!-- type popup menu -->
    <b-col
      v-if="(content.delivery_type === 2)"
      md="12"
    >
      <b-form-group
        label="Color"
        label-size="sm"
        label-class="mb-50"
      >
        <div
          v-for="(color, index) in navbarColors"
          :key="color"
          class="p-75 d-inline-block rounded-circle mr-1 cursor-pointer"
          :style="`background-color: ${color}`"
          :class="[{'border border-light': !index}, {'mark-active': selectColor === color}]"
          @click="changeColor(color)"
        >
          <feather-icon
            icon="CheckIcon"
            size="20"
            :class="(selectColor === color) ? 'text-white' : 'text-hide'"
          />
        </div>
        <b-button
          v-if="selectColor !== ''"
          variant="flat-dark"
          @click="resetColor"
        >
          Clear</b-button>
      </b-form-group>
    </b-col>
  </b-row>
</template>
<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormFile,
  BFormTextarea,
  BButton,
} from 'bootstrap-vue'
import { regex } from 'vee-validate/dist/rules'
import { ValidationProvider, extend } from 'vee-validate'
import vSelect from 'vue-select'
import { mapMutations } from 'vuex'
// import { mapMutations } from 'vuex'

// ieu validasi hese
// eslint-disable-next-line no-unused-vars
const util = file => new Promise((resolve, reject) => {
  let reader = new FileReader()
  reader.onload = e => {
    let data = e.target.result
    let img = new Image()
    img.src = data
    img.onload = () => {
      resolve({
        width: img.width,
        height: img.height,
      })
    }
  }
  reader.readAsDataURL(file)
})

extend('regex', {
  ...regex,
  message: 'This {_field_} field must be numeric!',
})

extend('max100', value => {
  if (value.length <= 100) {
    return true
  }
  return 'The {_field_} field must be max 100 char'
})

extend('max50', value => {
  if (value.length <= 50) {
    return true
  }
  return 'The {_field_} field must be max 50 char'
})

extend('dimensions824x386', {
  message: 'File dimensions {_field_} field must be 824 x 386 pixel',
  validate: async value => {
    let img = await util(value)
    if (img.width === 824 && img.height === 386) return true
    return false
  },
})

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormFile,
    ValidationProvider,
    vSelect,
    BFormTextarea,
    BButton,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    method: Number,
  },
  data() {
    return {
      // navbarColors: ['', 'primary', 'secondary', 'success', 'danger', 'warning', 'info', 'dark'],
      navbarColors: ['#e5083e', '#EA5455', '#FD7E14', '#6EC5B9', '#00B8CF', '#6610F2'],
      selectColor: '',
      medium_select: '',
      content: {
        delivery_type: 1,
        delivery_type_name: 'bima+ Push Notification',
        broadcast_title: '',
        broadcast_message: '',
        broadcast_description: '',
        broadcast_link: '',
        broadcast_image: null,
        broadcast_color: '#e5083e',
      },
      typeBima: [
        { value: 1, text: 'bima+ Push Notification' },
        { value: 2, text: 'Special Text Banner' },
      ],
      typeMenu: [
        { value: 1, text: 'List Menu' },
        { value: 2, text: 'Banner' },
      ],
      maxTitle: 50,
      remainingTitle: 50,
      maxMessage: 100,
      remainingMessage: 100,
      maxDesc: 100,
      remainingDesc: 100,
    }
  },
  computed: {
  },
  mounted() {
  },
  methods: {
    ...mapMutations('campaign', {
      setImageBimaUrl: 'SET_IMAGE_BIMA_URL',
    }),
    setContent() {
      this.$store.state.campaign.formCampaign.content = this.content
    },
    onFileChange(e) {
      const file = e.target.files[0]
      this.$store.state.campaign.formCampaign.broadcast_image = file
      this.setImageBimaUrl(URL.createObjectURL(file))
    },
    getText(arr, i) {
      const data = arr.find(item => item.value === i)
      return data.text
    },
    setType(val) {
      // console.log(val)
      this.$store.state.campaign.formCampaign.delivery_type = val
      this.content.delivery_type_name = this.getText(this.typeBima, val)
    },
    changeColor(color) {
      this.selectColor = color
      this.content.broadcast_color = color
    },
    resetColor() {
      this.selectColor = ''
      this.content.broadcast_color = '#e5083e'
    },
    countdownTitle() {
      this.remainingTitle = Math.max(0, this.maxTitle - this.content.broadcast_title.length)
    },
    countdownMessage() {
      this.remainingMessage = Math.max(0, this.maxMessage - this.content.broadcast_message.length)
    },
    countdownDesc() {
      this.remainingDesc = Math.max(0, this.maxDesc - this.content.broadcast_description.length)
    },
  },
}
</script>
<style scoped>
</style>
